import { Email, Phone, LocationOn, AccessTime } from '@mui/icons-material';
import './contact_form.scss';

const contactCards = [
  {
    icon: <Phone />,
    label: 'Telefono',
    value: '+39 348 265 9545',
    link: 'tel:+393482659545',
  },
  {
    icon: <Email />,
    label: 'Email',
    value: 'info@camillacinodesigndev.it',
    link: 'mailto:info@camillacinodesigndev.it',
  },
  {
    icon: <LocationOn />,
    label: 'Sede',
    values: ['Via Per S. Felice, 3', '41031 Camposanto (MO)'],
    link: 'https://maps.app.goo.gl/BQYJGGXAhvYHsSav6',
  },
  {
    icon: <AccessTime />,
    label: 'Orari',
    values: ['Lun - Ven: 9:00 - 18:00'],
    link: null,
  },
];

const ContactForm = () => {
  return (
    <div className="contact-form-wrapper">
      <div className="recapiti-grid">
        {contactCards.map((card, i) => {
          const Tag = card.link ? 'a' : 'div';
          const props = card.link
            ? { href: card.link, className: `recapito-card recapito-card--link`, 'aria-label': card.label }
            : { className: 'recapito-card' };

          return (
            <Tag key={i} {...props}>
              <span className="recapito-icon">{card.icon}</span>
              <div className="recapito-content">
                <span className="recapito-label">{card.label}</span>
                {'value' in card && card.value && (
                  <span className="recapito-value">{card.value}</span>
                )}
                {'values' in card && card.values && card.values.map((v, j) => (
                  <span key={j} className="recapito-value">{v}</span>
                ))}
              </div>
            </Tag>
          );
        })}
      </div>
    </div>
  );
};

export default ContactForm;
